import moment from 'moment';

export const totalInvoiceHours = (consultant, invoiceInformation) => {
    if (!invoiceInformation || invoiceInformation.length === 0) return 0;

    const invoiceHours = filterBySearchValue(consultant, invoiceInformation).map((inf) => inf.invoiceHours);
    const sumInvoiceHours = invoiceHours.reduce((acc, hours) => acc + hours, 0);

    return format(sumInvoiceHours, 1);
};

export const sumHours = (hours, propName) => {
    if (!hours || hours.length === 0) return 0;
    const sum = hours.reduce((acc, objectInArray) => acc + objectInArray[propName], 0);

    return format(sum, 1);
};

export const format = (value, precision) => {
    var multiplier = Math.pow(10, precision || 0);
    var oneDecimal = Math.round(value * multiplier) / multiplier;

    return oneDecimal.toLocaleString('sv-SE');
};

export const totalInvoiceAmount = (consultant, invoiceInformation) => {
    if (!invoiceInformation || invoiceInformation.length === 0) return 0;

    const invoiceAmounts = filterBySearchValue(consultant, invoiceInformation).map((inf) => inf.invoiceAmount);
    const sumInvoiceAmount = invoiceAmounts.reduce((acc, amount) => acc + amount, 0);

    return format(sumInvoiceAmount, 0);
};

export const filterBySearchValue = (consultant, invoiceInformation) => {
    if (!consultant || consultant.length === 0) return invoiceInformation;

    return invoiceInformation.filter((info) => {
        const employeeName = info.empName ? info.empName : info.invoiceCustomer;
        if (!employeeName) return false;

        return employeeName.toUpperCase().includes(consultant.toUpperCase());
    });
};

export const getValues = (consultant, invoiceInformation) => {
    const sumHours = totalInvoiceHours(consultant, invoiceInformation);
    const sumAmount = totalInvoiceAmount(consultant, invoiceInformation);
    const filtered = filterBySearchValue(consultant, invoiceInformation);

    return { sumHours: sumHours, sumAmount: sumAmount, filtered: filtered };
};

export const FilterList = (list, startDate, endDate) => {
    if (list.find((obj) => obj.invoiceMon)) {
        const endDateMoment = moment(
            moment(endDate)
                .format('YYYY-MM')
                .toString()
        ).add(1, 'month');
        const startDateMoment = moment(
            moment(startDate)
                .format('YYYY-MM')
                .toString()
        ).add(-1, 'days');
        const filtered = list.filter((inv) => moment(inv.invoiceMon).isBetween(startDateMoment, endDateMoment));
        return filtered;
    }

    if (list.find((obj) => obj.date)) {
        const endDateMoment = moment(
            moment(endDate)
                .format('YYYY-MM-DD')
                .toString()
        ).add(1, 'month');
        const startDateMoment = moment(
            moment(startDate)
                .format('YYYY-MM-DD')
                .toString()
        ).add(-1, 'days');

        const filtered = list.filter((inv) => moment(inv.date).isBetween(startDateMoment, endDateMoment));
        return filtered;
    }
};

export const addMonth = (date, month) => {
    const copy = new Date(Number(date));
    copy.setMonth(copy.getMonth() + month);
    return copy;
};
